<template>
  <v-card outlined style="margin-bottom: 24px">
    <UpdateReviewGrade :state="updateLeadDialog" :profile="profile" @refresh="refresh" @closeDialog="closeDialog" />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Chi tiết điểm</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="updateLead"
        style="height: 18px"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhật
      </v-btn>
    </div>

    <template>
      <div v-for="mark in profile.marks" :key="mark.id">
        <div class="pl-6 mb-2">
          <strong>{{ mark.name }}</strong>
        </div>
        <v-row class="px-6 pb-6" no-gutters>
          <v-col cols="6">
            <div class="grey--text mb-0 mt-0">
              Điểm trước phúc khảo :
              <strong style="color: black">{{ mark.preReviewValue ? mark.preReviewValue : mark.value }}</strong> / Điểm
              sau phúc khảo:
              <strong style="color: red">{{ mark.reviewedValue || '-' }}</strong>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </v-card>
</template>
<script>
import UpdateReviewGrade from './UpdateReviewGrade.vue'

export default {
  props: {
    profile: Object
  },
  components: { UpdateReviewGrade },
  data() {
    return {
      updateLeadDialog: false,
      studentDialog: false,
      noteDialog: false
    }
  },
  computed: {
    hasStudentData() {
      return this.profile.data && this.profile.data.student && this.profile.data.student.length > 0
    }
  },
  methods: {
    updateLead() {
      this.updateLeadDialog = true
    },
    closeDialog() {
      this.updateLeadDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },

    navigateToDocument(code) {
      const url = `/admin/document?code=${code}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style>
.no-hover.v-btn--plain .v-btn__content {
  opacity: 1 !important;
}
</style>
